import CustomerDetail from './CustomerDetail';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
// import AzureUserInfo from '../AzureUserInfo';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
// import Customer from './Customer';
// import NewInstance from './NewInstance';
import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Paper from '@mui/material/Paper';
import { visuallyHidden } from '@mui/utils';
import { makeStyles } from '@mui/styles';
import IconButton from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';
import LastPageIcon from '@mui/icons-material/LastPage';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import axios from 'axios';
import { useHistory } from 'react-router-dom';

// const LightTooltip = styled(({ className, ...props }) => (
//     <Tooltip {...props} classes={{ popper: className }} />
//   ))(({ theme }) => ({
//     [`& .${tooltipClasses.tooltip}`]: {
//       backgroundColor: theme.palette.common.white,
//       color: 'rgba(0, 0, 0, 0.87)',
//       boxShadow: theme.shadows[1],
//       fontSize: 11,
//     },
//   }));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

function getStyles(name: any, personName: any, theme: any) {
    return {
        fontWeight:
            personName.indexOf(name) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
    };
}

function descendingComparator(a: any, b: any, orderBy: any) {
    var x = a[orderBy];
    var y = b[orderBy];

    if (a[orderBy] == null) {
        if (orderBy == 'dateLive') {
            x = '01/01/2000';
        }
        if (orderBy == 'dateBuilt') {
            x = '01/01/2000';
        }
    }
    if (b[orderBy] == null) {
        if (orderBy == 'dateLive') {
            y = '01/01/2000';
        }
        if (orderBy == 'dateBuilt') {
            x = '01/01/2000';
        }
    }
    if (y < x) {
        return -1;
    }
    if (y > x) {
        return 1;
    }
    return 0;
}


function getComparator(order: any, orderBy: any) {
    return order === 'desc'
        ? (a: any, b: any) => descendingComparator(a, b, orderBy)
        : (a: any, b: any) => -descendingComparator(a, b, orderBy);
}

function stableSort(array: any, comparator: any) {
    const stabilizedThis = array.map((el: any, index: any) => [el, index]);
    stabilizedThis.sort((a: any, b: any) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el: any) => el[0]);
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexShrink: 0,
        //marginLeft: theme.spacing(2.5),
    },
    // alert1: { backgroundColor: "#E74C3C", color: "white !important" },
    hideCell: {
        display: "none !important",
    },
    myTable: {
        '& th': {
            padding: "2px 2px"
            // , paddingLeft:"10px"
        },
        '& td': {
            borderBottom: "1px solid #EAEDED",
            whiteSpace: "nowrap",
            height: "25px",
            padding: "2px 2px",
            // paddingLeft:"10px"

        },
        '& tr:nth-child(even)': { backgroundColor: "#FBFCFC" }
    },
    myInput: {
        border: "1px solid #BDC3C7",
        padding: "4px 7px",
        width: "100%",
        '&:focus': {
            border: "1px solid #5DADE2",
            outline: "none",
            color: "#5DADE2",
        },
    }

}));

let mySearchTimer: any;
// let myRefreshTimer: any;
//let searchData01='';
export default function Customers({
    handleCustomerListCallBack,
    search,
    queryType,
}: {
    handleCustomerListCallBack: (serialNumber: number, queryType: number) => void;
    search: string;
    queryType: number;
}
) {
    //searchData01=search;
    const theme = useTheme();
    //const searchData=search;
    const classes = useStyles();
    const [order, setOrder] = React.useState<string>('asc');
    const [searchCustomer, SetSearchCustomer] = React.useState<string>('');
    
    const [orderBy, setOrderBy] = React.useState('CustomerName');
    const [selected, setSelected] = React.useState([] as any);
    const [page, setPage] = React.useState(0);
    const [totalRowsCount, SetTotalRowsCount] = React.useState(0);

    const [dense, setDense] = React.useState(true);
    const [rowsPerPage, setRowsPerPage] = React.useState(20);
    const [data, SetData] = React.useState([] as any);
    const [currentRow, SetCurrentRow] = React.useState([] as any);
    // const [showCustomer, SetShowCustomer] = React.useState(false);
    // const [showNewInstance, SetShowNewInstane] = React.useState(false);
    // const [serialNumber, SetSerialNumber] = React.useState(0);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const [customerType, SetCustomerType] = React.useState(1);
    const [showCustomerDetail, SetShowCustomerDetail] = React.useState(false);
    // const [currentUsers, SetCurrentUsers] = React.useState('');

    const history = useHistory();

    var bearer = 'Bearer ' + localStorage.getItem("token");
    const headers = {
        'Authorization': bearer

    };
    // function CloseCustomerDrawer(value: number = 0) {
    //     SetShowCustomer(value == 0 ? false : true);
    // }

    // function CloseNewInstanceDrawer(value: number = 0) {
    //     SetShowNewInstane(value == 0 ? false : true);
    // }

    // function AddNew() {
    //     SetShowNewInstane(true);
    // }
    // function SaveChanges(rowCustomer: any) {
    //     let date: Date = new Date();

    //     Object.keys(rowCustomer).forEach((key) => {
    //         let value = rowCustomer[key];
    //         if (key == 'dateLive' && value != null) {
    //             const d = new Date(value);
    //             value = d.getFullYear() + "-" + d.getMonth() + "-" + d.getDate();
    //         }
    //         currentRow[key] = value;
    //     });
    //     SetShowCustomer(false);

    //     const request = {
    //         "dateLive": rowCustomer.dateLive
    //     }

    //     let url = "";
    //     if (queryType === 0) {
    //         url = window.name + "IdealCustomers/";
    //     }
    //     else if (queryType === 1) {
    //         url = window.name + "InfinityCustomers/";
    //     }

    //     axios.put(url + rowCustomer.serialNumber,
    //         request, {
    //         headers
    //     })
    //         .then((response: any) => {
    //         })
    //         .catch((err: any) => {
    //             console.log(err);
    //         })
    // }


    const useStyles1 = makeStyles((theme: any) => ({
        root: {
            flexShrink: 0,
        },
    }));

    const handleRowClick = (currentRow: any) => {
        SetCurrentRow(currentRow);
        SetShowCustomerDetail(true);
        //SetShowCustomer(true);
    };

    // const displayAzureUser = (serialNumber: any) => {
    //     SetSerialNumber(serialNumber);
    //     //handleCustomerListCallBack(serialNumber, queryType);
    // };


    const headCells = [
        { id: 'CustomerName', numeric: false, disablePadding: false, label: 'CustomerName' },
        { id: 'SystemID', numeric: false, disablePadding: false, label: 'SystemID' },
        { id: 'LastCall', numeric: false, disablePadding: false, label: 'LastCall' },
        { id: 'DBUpdate', numeric: false, disablePadding: false, label: 'DB Update' },

        { id: 'IPAddress', numeric: false, disablePadding: false, label: 'IPAddress' },
        { id: 'AppVersion', numeric: false, disablePadding: false, label: 'App Version' },
        { id: 'ProgramUpdateStatus', numeric: false, disablePadding: false, label: 'Program Updates' },

        { id: 'DatabaseName', numeric: false, disablePadding: false, label: 'Database' },
        { id: 'ServiceVersion', numeric: false, disablePadding: false, label: 'Service#' },
        
        // { id: 'wvdserver', numeric: false, disablePadding: false, label: 'WVDServer' },
        // { id: 'dateBuilt', numeric: false, disablePadding: false, label: 'DateBuilt' },
        // { id: 'dateLive', numeric: false, disablePadding: false, label: 'DateLive' },
        // { id: 'companyPW', numeric: false, disablePadding: false, label: 'Password' },
        // { id: 'idealVersion', numeric: false, disablePadding: false, label: 'Version#' },
        // { id: 'idealSystemService', numeric: false, disablePadding: false, label: 'SysService' },
        // { id: 'idealConnector', numeric: false, disablePadding: false, label: 'Connector' },
        // { id: "Edit", numeric: false, disablePadding: false, label: "" },
    ];
    // const headCellsInfinity = [
    //     { id: 'SystemID', numeric: false, disablePadding: false, label: 'SystemID' },
    //     { id: 'serialNumber', numeric: true, disablePadding: false, label: 'Serial#' },
    //     { id: 'dbserver', numeric: false, disablePadding: false, label: 'DBServer' },
    //     { id: 'wvdserver', numeric: false, disablePadding: false, label: 'WVDServer' },
    //     { id: 'dateBuilt', numeric: false, disablePadding: false, label: 'DateBuilt' },
    //     { id: 'dateLive', numeric: false, disablePadding: false, label: 'DateLive' },
    //     { id: "Edit", numeric: false, disablePadding: false, label: "" },
    // ];


    function EnhancedTableHead(props: any) {
        const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } =
            props;
        const createSortHandler = (property: any) => (event: any) => {
            onRequestSort(event, property);
        };

        return (
            <TableHead>
                <TableRow>
                    {/* {(queryType == 0 ? headCells : headCellsInfinity).map((headCell) => ( */}
                    {headCells.map((headCell) => (
                        <TableCell
                            style={{ backgroundColor: "#F2F3F4" }}
                            key={headCell.id}
                            align={headCell.numeric ? 'right' : 'left'}
                            padding={headCell.disablePadding ? 'none' : 'normal'}
                            sortDirection={orderBy === headCell.id ? order : false}
                        >
                            <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={orderBy === headCell.id ? order : 'asc'}
                                onClick={createSortHandler(headCell.id)}
                            >
                                {headCell.label}
                                {orderBy === headCell.id ? (
                                    <Box component="span" sx={visuallyHidden}>
                                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                    </Box>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>
        );
    }

    EnhancedTableHead.propTypes = {
        numSelected: PropTypes.number.isRequired,
        onRequestSort: PropTypes.func.isRequired,
        onSelectAllClick: PropTypes.func.isRequired,
        order: PropTypes.oneOf(['asc', 'desc']).isRequired,
        orderBy: PropTypes.string.isRequired,
        rowCount: PropTypes.number.isRequired,
    };
    function TablePaginationActions(props: any) {
        const classes = useStyles1();
        const theme: any = useTheme();
        const { count, page, rowsPerPage, onChangePage } = props;

        const handleFirstPageButtonClick = (event: any) => {
            setPage(0)
        };

        const handleBackButtonClick = (event: any) => {
            setPage(page - 1)
        };

        const handleNextButtonClick = (event: any) => {
            setPage(page + 1)
        };

        const handleLastPageButtonClick = (event: any) => {
            setPage(Math.max(0, Math.ceil(count / rowsPerPage) - 1))
        };

        return (
            <div className={classes.root}>
                <IconButton
                    onClick={handleFirstPageButtonClick}
                    disabled={page === 0}
                    aria-label="first page"
                >
                    {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
                </IconButton>
                <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
                    {theme.direction === 'rtl' ? <KeyboardArrowRightIcon /> : <KeyboardArrowLeftIcon />}
                </IconButton>
                <IconButton
                    onClick={handleNextButtonClick}
                    disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                    aria-label="next page"
                >
                    {theme.direction === 'rtl' ? <KeyboardArrowLeftIcon /> : <KeyboardArrowRightIcon />}
                </IconButton>
                <IconButton
                    onClick={handleLastPageButtonClick}
                    disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                    aria-label="last page"
                >
                    {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
                </IconButton>
            </div>
        );
    }

    TablePaginationActions.propTypes = {
        count: PropTypes.number.isRequired,
        onChangePage: PropTypes.func.isRequired,
        page: PropTypes.number.isRequired,
        rowsPerPage: PropTypes.number.isRequired,
    };

    useEffect(() => {
        //alert('useEffect');
        clearTimeout(mySearchTimer);
        mySearchTimer = setTimeout(FetchData, (1000) * 1); //1 sec

    }, [searchCustomer]);



    useEffect(() => {
        FetchData();

    }, [queryType, rowsPerPage, page, orderBy, order, customerType]);

    function FetchData() {
        // clearTimeout(myRefreshTimer);

        let obj: any = new Object();
        obj.QueryType="Customer";
        obj.CustomerTypeCode = customerType;
        obj.RowsPerPage = rowsPerPage;
        obj.PageNumber = page;
        obj.Search = searchCustomer;
        obj.OrderBy = orderBy;
        obj.Order = order;
        let jsonString = JSON.stringify(obj);
        //alert(searchData01);

        let url = "http://csars-cssdata:5111/api/Infinity/" + jsonString;
        //let url='http://csars-cssdata:5111/api/Customer/%7B%22CustomerTypeCode%22%3A1%2C%20%22RowsPerPage%22%3A15%2C%20%22PageNumber%22%3A2%7D';
        //let url = "http://infinitylogging.csidealer.com:5111/api/Customer/" + jsonString;
        //let url = "http://csars-cssdata:5111/api/Customer/%7B%22CustomerTypeCode%22%3A1%7D";
        //http://localhost:5042/swagger/index.html
        //alert(url);


        
        fetch(url)
            .then(response => (
                //alert(response),
                response.json()
            ))
            .then(data =>
            (
                //alert(data),
                // if (typeof data == 'undefined'){},
                //alert(data.length),
                SetData(data),
                //alert(data[0].TotalRowsCount),
                SetTotalRowsCount(data.length > 0 ? data[0].TotalRowsCount : 0)
                //TotalRowsCount
                //SetData(typeof data == 'undefined'?null:data)
                //  ,myRefreshTimer = setTimeout(FetchData, (1000 * 10) * 1)

            )

            ).catch(
                error => (alert('Error: ' + error)
                // myRefreshTimer = setTimeout(FetchData, (1000 * 30) * 1)
                
                    //,SetShowWorking(false)
                )

            );

    }


    const handleRequestSort = (event: any, property: any) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleSelectAllClick = (event: any) => {

    };

    const handleClick = (event: any, name: any) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected: any = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
    };

    const handleChangePage = (event: any, newPage: any) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: any) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleChangeDense = (event: any) => {
        setDense(event.target.checked);
    };

    const isSelected = (name: any) => selected.indexOf(name) !== -1;

    // Avoid a layout jump when reaching the last page with empty rows.
    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - GetData().length) : 0;

    function GetData() {
        //return data.filter(filterRow);
        return data;
    }
    // function filterRow(element: any, index: any, array: any) {
    //     if (data.length > 0) {
    //         var obj1 = data[0];
    //         var keys = Object.keys(obj1);
    //         let i = 0;
    //         for (i = 0; i < keys.length; i++) {
    //             let cellValue = String(element[keys[i]]);
    //             if (cellValue.toLowerCase().includes(search.toLowerCase())) { return true; }
    //         }
    //     }
    //     return false;
    // }

    function ShopPopover(e: any, currentRow: any, tag: any) {
        setAnchorEl(e.currentTarget);
        //alert(currentRow.CurrentUsers);
        //SetCurrentUsers(currentRow.CurrentUsers.replace(',','\n')
        const myArray = currentRow.CurrentUsers.split(',');
        // alert(myArray);
        // alert(myArray.length);
        // alert(myArray[0]);
        //SetCurrentUsers(currentRow.CurrentUsers);
        SetCurrentRow(currentRow);

    }

    // function NewlineText(props: any) {
    //     const text = props.text;
    //     return <div>{text}</div>;

    // }

    const handleCloseAdmin = () => {
        setAnchorEl(null);
    };

    const GetCurrentUsers = () => {
        var x = String(currentRow.CurrentUsers);
        x = x.replace('Users: ', '')
        let i = x.indexOf(' ');
        if (i > 0) x = x.substring(i);
        return x.split(',');
    }

    const GetActiveUsers = () => {
        var x = String(currentRow.CurrentUsers);
        x = x.replace('Users: ', '')
        let i = x.indexOf(' ');
        if (i > 0) x = x.substring(0, i);
        return x;
    }
    function CompanyNameAddress(props: any) {
        const { customerName, row } = props;

        return (
            <div>{row.CustomerName} ({row.SystemID})
                <br></br>{row.Address}
                <br></br>Phone: {row.Phone}
                <br></br>Contact: {row.ContactPerson}
            </div>
        )
    }

    const handleCustomerTypeChange = (event: any) => {
        const {
            target: { value },
        } = event;
        SetCustomerType(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };

function ApplyChanges(){

}
function SetCustomerDetail(value: number = 0) {
    SetShowCustomerDetail(value == 0 ? false : true);
}


    return (
        <Box display="flex" justifyContent="center" alignItems="center" >
            <Box sx={{ width: 'auto', display: "table" }}>
                <Paper sx={{ width: 'auto', mb: 2 }}>
                <Table>
                        <tr>
                            <td>
                                <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                                    {/* <InputLabel id="demo-simple-select-standard-label">Age</InputLabel> */}
                                    <Select
                                        labelId="demo-simple-select-standard-label"
                                        id="demo-simple-select-standard"
                                        value={customerType}
                                        onChange={handleCustomerTypeChange}
                                        label="Age"
                                    >
                                        <MenuItem value={1}>Infinity</MenuItem>
                                        <MenuItem value={0}>Enterprise</MenuItem>
                                        <MenuItem value={3}>SoftBiz</MenuItem>
                                        <MenuItem value={4}>SoftPower</MenuItem>
                                    </Select>
                                </FormControl>

                            </td>
                            <td>
                            <input placeholder='Search...' className={classes.myInput} type="text" style={{ width: "200px", marginLeft:"15px" }} value={searchCustomer} onChange={(e: any) => { SetSearchCustomer(e.target.value); ApplyChanges() }} ></input>

                            </td>
                            <td style={{ width: "100%" }}>
                                <TablePagination
                                    rowsPerPageOptions={[15, 20, 50, 100]}
                                    component="div"
                                    count={totalRowsCount}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                    ActionsComponent={TablePaginationActions}

                                />

                            </td>
                        </tr>
                    </Table>                    
                    <TableContainer>
                        <Table
                            className={classes.myTable}
                            sx={{ minWidth: 750 }}
                            aria-labelledby="tableTitle"
                            size={dense ? 'small' : 'medium'}
                        >
                            <EnhancedTableHead
                                numSelected={selected.length}
                                order={order}
                                orderBy={orderBy}
                                onSelectAllClick={handleSelectAllClick}
                                onRequestSort={handleRequestSort}
                                rowCount={GetData().length}
                            />
                            <TableBody>
                                {typeof (data) !== 'undefined' && data != null && (


                                    //{
                                    data.map((row: any, index: any) => {
                                        const isItemSelected = row.CustomerID == currentRow.CustomerID ? true : false;
                                        let dDBVersion='';
                                        if(typeof (row.DatabaseVersion) != 'undefined' && dDBVersion!=null) dDBVersion=  ' (' + row.DatabaseVersion + ')'
                                        let DBName = row.DatabaseName  + dDBVersion;
                                        if (typeof (DBName) == 'undefined' || DBName==null ) {DBName='' }
                                        let currentUsers = row.CurrentUsers;
                                        if (currentUsers != null) {
                                            currentUsers = currentUsers.replace('Users: ', '');
                                            let i = currentUsers.indexOf(' ');
                                            if (i > 0) { currentUsers = currentUsers.substr(0, i) }
                                        }
                                        // let users = ' (' + currentUsers + '/' + row.Users + ')';
                                        if (typeof (currentUsers) == 'undefined') {currentUsers='0' }
                                        let users = currentUsers + '/' + row.Users;
                                        let dbBackup = '';
                                        let updateStatus = row.ProgramUpdateStatus;
                                        if (updateStatus == null) updateStatus = '';
                                        if (updateStatus.length > 40) { updateStatus = updateStatus.substr(0, 40) + '...'; }
                                        let nameAddress = row.CustomerName + ' ' + row.Address;
                                        let DBBackup='(' + row.LastBackupDuration + ' Min) (' + row.DaysSinceLastBackup +')';
                                        if (typeof (row.LastBackupDuration) == 'undefined') {DBBackup='' }

                                        return (
                                            <TableRow
                                                hover
                                                role="checkbox"
                                                key={row.CustomerID}
                                                selected={isItemSelected}
                                                onClick={(event) => handleRowClick(row)}
                                                >
                                                <TableCell>
                                                    <Tooltip arrow title={<CompanyNameAddress customerName={row.CustomerName} row={row} />}>
                                                        <span>{row.CustomerName}</span>
                                                    </Tooltip>
                                                    <Tooltip arrow title="Active Users">
                                                        <Chip style={{ marginLeft: "5px" }} label={users} size="small" variant="outlined" onClick={e => ShopPopover(e, row, 'MessageCount')} ></Chip>
                                                    </Tooltip>
                                                </TableCell>
                                                <TableCell align='left'
                                                // style={{ cursor: "pointer", textDecoration: "underline" }}
                                                // onClick={(event) => displayAzureUser(row.SystemID)}
                                                >
                                                    {row.SystemID}
                                                </TableCell>

                                                <TableCell style={{paddingRight:"10px"}}>{row.LastCall}</TableCell>
                                                <TableCell>{DBBackup}</TableCell>
                                                <TableCell style={{paddingRight:"8px"}}>{row.IPAddress}</TableCell>

                                                <TableCell>{row.AppVersion}</TableCell>
                                                <TableCell>
                                                    <table cellPadding={0} cellSpacing={0} style={{border:"0px solid red", paddingLeft:"0px"}} >
                                                        <tr>
                                                            <td valign="middle">
                                                                {row.EnableAutoUpdate && (
                                                                    <Tooltip title="Auto Update Enabled" arrow>
                                                                        <CheckCircleOutlineRoundedIcon sx={{ fontSize: 20 }} ></CheckCircleOutlineRoundedIcon>
                                                                    </Tooltip>

                                                                )}
                                                            </td>
                                                            <td style={{ paddingLeft: "5px" }}>{updateStatus}</td>
                                                        </tr>
                                                    </table>
                                                </TableCell>

                                                <TableCell>{DBName}</TableCell>
                                                <TableCell>{row.ServiceVersion}</TableCell>
                                                

                                                {/* <TableCell
                                                    style={{ color: "gray", cursor: "pointer", textDecoration: "underline" }}
                                                    onClick={(event) => handleRowClick(row)}><EditIcon style={{ fontSize: "small" }}></EditIcon></TableCell> */}
                                            </TableRow>
                                        );
                                    })
                                    //}
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>


                </Paper>

                {/* <FormControl sx={{ m: 1, width: 300 }}>
                        <InputLabel id="demo-multiple-name-label">Name</InputLabel>
                        <Select
                            labelId="demo-multiple-name-label"
                            id="demo-multiple-name"
                            multiple
                            value={customerType}
                            onChange={handleCustomerTypeChange}
                            input={<OutlinedInput label="Name" />}
                            MenuProps={MenuProps}
                        >
                            {CustomerType.map((name) => (
                                <MenuItem
                                    key={name}
                                    value={name}
                                 style={getStyles(name, customerType, theme)}
                                >
                                    {name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>                 */}
                {/* <Customer open={showCustomer} rowCustomer={currentRow} SaveChanges={SaveChanges} onClose={CloseCustomerDrawer} />
                {(serialNumber > 0) && (
                    <AzureUserInfo search={''} serialNumber={serialNumber} queryType={queryType}></AzureUserInfo>
                )} */}

                {/* <NewInstance open={showNewInstance} onClose={CloseNewInstanceDrawer} queryType={queryType} /> */}

                {/* <div style={{ position: "fixed", bottom: "10px", left: "5px" }}>
                    <table>
                        <tr>
                            <td>
                                <Fab variant="extended" size="medium" color="primary" onClick={() => AddNew()} title='Add New'>
                                    {<AddIcon></AddIcon>}Add New &nbsp;
                                </Fab>
                            </td>
                        </tr>
                    </table>
                </div> */}

                <Popover
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleCloseAdmin}
                    anchorOrigin={{
                        vertical: 'center',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                >
                    <Typography >
                        <div style={{ padding: "5px 10px", fontSize: "small" }}>
                            {currentRow.CustomerName}<br></br>
                            Licensed Users: {currentRow.Users}<br></br>
                            Active Users: {GetActiveUsers()}<br></br>
                            As of: {currentRow.CurrentUsersUpdated}
                            <hr></hr>

                            {GetCurrentUsers().map((row: any) => {
                                return (
                                    <div>{row}</div>
                                )
                            })}
                        </div>

                    </Typography>
                </Popover>

            </Box>
            <CustomerDetail open={showCustomerDetail} currentRow={currentRow} onClose={SetCustomerDetail} />
        </Box>
    );
}
